(function($) {
  
  $(document).ready(function() {
      
  });
  
})(jQuery);

function initHeaderQuickmenuMobile(){
  var $ = jQuery;
  $('.js-close-mobile-menu').click(function(){
    $('body').removeClass('has-open-menu');
    $('body').removeClass('mobile-menu-loggedin');
    $('head meta[name="theme-color"]').attr('content','#fff');
  });
}